import { render, staticRenderFns } from "./OrderInfomation.vue?vue&type=template&id=0a0a75aa&scoped=true"
import script from "./OrderInfomation.vue?vue&type=script&lang=js"
export * from "./OrderInfomation.vue?vue&type=script&lang=js"
import style0 from "./OrderInfomation.vue?vue&type=style&index=0&id=0a0a75aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a75aa",
  null
  
)

export default component.exports